export function getFileType(fileName: string): "image" | "pdf" | "other" {
  const extension = fileName.split(".").pop()?.toLowerCase();

  const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"];
  const pdfExtensions = ["pdf"];

  if (imageExtensions.includes(extension || "")) {
    return "image";
  }

  if (pdfExtensions.includes(extension || "")) {
    return "pdf";
  }

  return "other";
}

export function getFileIcon(fileName: string): string {
  const type = getFileType(fileName);

  switch (type) {
    case "image":
      return "🖼️";
    case "pdf":
      return "📄";
    default:
      return "📎";
  }
}

export function isImage(fileName: string): boolean {
  return getFileType(fileName) === "image";
}

export function isPdf(fileName: string): boolean {
  return getFileType(fileName) === "pdf";
}

export function getFileNameWithoutExtension(fileName: string): string {
  const nameWithoutExt = fileName.split(".").slice(0, -1).join(".");
  return nameWithoutExt === "" ? fileName : nameWithoutExt;
}

export function getFileExtension(fileName: string): string {
  const lastDot = fileName.lastIndexOf(".");
  if (lastDot > 0 && lastDot < fileName.length - 1) {
    return fileName.substring(lastDot + 1).toLowerCase();
  }
  return "";
}
